import { captureException } from '@sentry/react';
import { isDev } from 'lib/utils/isDev';

export const logException = isDev() ? console.warn : captureException;
